import actions from './actions';
import mutations from './mutations';
import state from './state';
import getters from './getters';

const app = {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
};

export default app;
